import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
import VueMoment from "vue-moment";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faSave, faPaperPlane, faSpinner, faTrash, faAngleLeft, faAngleDoubleLeft, faAngleRight, faAngleDoubleRight, faCalendarAlt, faCogs, faUsersCog, faCalendarPlus, faClipboardList, faFastBackward, faFastForward, faSyncAlt, } from "@fortawesome/free-solid-svg-icons";
// @ts-ignore
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faSave, faPaperPlane, faSpinner, faTrash, faAngleLeft, faAngleDoubleLeft, faAngleRight, faAngleDoubleRight, faCalendarAlt, faCogs, faUsersCog, faCalendarPlus, faClipboardList, faFastBackward, faFastForward, faSyncAlt);
Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(VueMoment);
Vue.component("fa-icon", FontAwesomeIcon);
import Index from "./pages/Index.vue";
import EmbedCalendar from "./pages/EmbedCalendar.vue";
import Login from "./pages/Login.vue";
import Logout from "./pages/Logout.vue";
import ManageEvent from "./pages/ManageEvent.vue";
import Settings from "./pages/Settings.vue";
import NotFound from "./pages/NotFound.vue";
import Calendar from "./pages/Calendar.vue";
import Users from "./pages/Users.vue";
import EventList from "./pages/EventList.vue";
const basicRoutes = {
    "": Index,
    "/embed": EmbedCalendar,
    "/login": Login,
    "/logout": Logout,
    "/event": ManageEvent,
    "/settings": Settings,
    "/calendar": Calendar,
    "/users": Users,
    "/list": EventList,
};
const routes = {};
for (const key in basicRoutes) {
    routes[key] = routes[key + "/"] = routes[key + "/index.html"] = basicRoutes[key];
}
import Debug from "./pages/Debug.vue";
if (process.env.NODE_ENV === "development") {
    routes["/debug"] = Debug;
}
new Vue({
    data: {
        currentRoute: window.location.pathname,
    },
    computed: {
        ViewComponent() {
            return routes[this.currentRoute] || NotFound;
        },
    },
    render(h) {
        return h(this.ViewComponent);
    },
}).$mount("#app");
//# sourceMappingURL=main.js.map